import { render } from "./InitComponent.vue?vue&type=template&id=31409a67&ts=true"
import script from "./InitComponent.vue?vue&type=script&lang=ts"
export * from "./InitComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__